webpackJsonp([135882870033682],{

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/7.be94afa5.jpg";

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/china-artful-adventures.48ba161f.jpg";

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/china-smartkids.6b0ebb89.jpg";

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/japan-artful-adventures.78be580d.jpg";

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/landscapepainting.12bd68d6.jpg";

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resourcePageTitleQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(10);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Gallery = __webpack_require__(25);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _ = __webpack_require__(838);
	
	var _2 = _interopRequireDefault(_);
	
	var _japanArtfulAdventures = __webpack_require__(850);
	
	var _japanArtfulAdventures2 = _interopRequireDefault(_japanArtfulAdventures);
	
	var _landscapepainting = __webpack_require__(854);
	
	var _landscapepainting2 = _interopRequireDefault(_landscapepainting);
	
	var _chinaArtfulAdventures = __webpack_require__(842);
	
	var _chinaArtfulAdventures2 = _interopRequireDefault(_chinaArtfulAdventures);
	
	var _chinaSmartkids = __webpack_require__(843);
	
	var _chinaSmartkids2 = _interopRequireDefault(_chinaSmartkids);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Lightbox from 'react-images'
	
	
	var DEFAULT_IMAGES = [{
	  id: '1',
	  src: '/china/resources/tomb-figures',
	  thumbnail: _2.default,
	  caption: 'Lesson Plan: Northern Wei Tomb Retinue',
	  description: 'Intended Age Group: Grades 5–8'
	}, {
	  id: '2',
	  src: '/china/resources/landscape-painting',
	  thumbnail: _landscapepainting2.default,
	  caption: 'Closer Look: Chinese Landscape Painting during the Song Dynasty',
	  description: 'Intended Age Group: Grades 9-12'
	}, {
	  id: '3',
	  src: '/japan/resources/artful-adventures',
	  thumbnail: _japanArtfulAdventures2.default,
	  caption: 'Self-Guided Activity: Artful Adventures Japan',
	  description: 'Intended Age Group: Ages 7-12'
	}, {
	  id: '4',
	  src: '/china/resources/artful-adventures',
	  thumbnail: _chinaArtfulAdventures2.default,
	  caption: 'Self-Guided Activity: Artful Adventures China',
	  description: 'Intended Age Group: Ages 7-12'
	}, {
	  id: '5',
	  src: '/china/resources/smartkids',
	  thumbnail: _chinaSmartkids2.default,
	  caption: 'Self-Guided Activity: Chinese Tomb',
	  description: 'Intended Age Group: Ages 3-8'
	}];
	
	var TeacherResources = function (_React$Component) {
	  _inherits(TeacherResources, _React$Component);
	
	  function TeacherResources() {
	    _classCallCheck(this, TeacherResources);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  TeacherResources.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    var siteTitleSub = 'Teacher Resources';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitleSub + ' | ' + siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'main' },
	        _react2.default.createElement(
	          'section',
	          { id: 'one' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Teacher Resources'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { id: 'two' },
	          _react2.default.createElement(_Gallery2.default, {
	            images: DEFAULT_IMAGES.map(function (_ref) {
	              var id = _ref.id,
	                  src = _ref.src,
	                  thumbnail = _ref.thumbnail,
	                  caption = _ref.caption,
	                  description = _ref.description;
	              return {
	                src: src,
	                thumbnail: thumbnail,
	                caption: caption,
	                description: description
	              };
	            })
	          })
	        )
	      )
	    );
	  };
	
	  return TeacherResources;
	}(_react2.default.Component);
	
	exports.default = TeacherResources;
	var resourcePageTitleQuery = exports.resourcePageTitleQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-resources-js-74080771347f5c4bccb7.js